import { ThemeProperties } from '../../../core';

export interface HelpTextTheme {
	baseFont: string;
	baseMarginTop: string;
	baseMarginLeft: string;
	baseTextColor: string;
	invalidTextColor: string;
}
export const theme = new ThemeProperties('helpText');
